<template>
  <li class="item">
    <span><slot /></span>
    <button
      v-if="removable"
      type="button"
      class="btn btn-link item__btn ml-1"
      :aria-label="`Remove ${value}`"
      @click="remove(value)"
      @keyup.enter="remove(value)"
    >
      <elIcon
        name="x"
        color="#000"
      />
    </button>
  </li>
</template>

<script>
import elIcon from './elIcon.vue'

export default {
  components: {
    elIcon
  },
  props: {
    value: {
      type: String,
      required: true
    },
    removable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['remove'],
  methods: {
    remove(value) {
      this.$emit('remove', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@ui/styles/src/scss/utils/lib";

.item {
  @extend %flex-v-center;

  &__btn {
    padding: 0;
    line-height: 1;

    &:hover,
    &:focus {
      svg {
        fill: $red-50;
      }
    }
  }
}
</style>
